var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"about"},[_c('ul',[_c('li',[_c('dl',[_c('dt',[_vm._v("名前 ")]),_c('dd',[_vm._v(" ：出口裕樹")])])]),_c('li',[_c('dl',[_c('dt',[_vm._v("生年月日")]),_c('dd',[_vm._v(" ：1994/05/07")])])]),_c('li',[_c('dl',[_c('dt',[_vm._v("Email ")]),_c('dd',[_vm._v(" ：deguchi37458@gmail.com")])])])])])
}]

export { render, staticRenderFns }